import * as React from 'react';
import * as styles from '../../styles/image.css';
var MIME_DICT = new Map([['apng', 'image/apng'], ['bmp', 'image/bmp'], ['gif', 'image/gif'], ['ico', 'image/ico'], ['cur', 'image/ico'], ['jpeg', 'image/jpeg'], ['jpg', 'image/jpeg'], ['png', 'image/png'], ['svg', 'image/svg'], ['webp', 'image/webp']]);
var getFileExt = function getFileExt(src) {
  var pathname = src.split(/[?#]/)[0];
  var resultArray = pathname.split(/\./);
  return resultArray[resultArray.length - 1];
};
var getMimeType = function getMimeType(src) {
  return MIME_DICT.get(getFileExt(src));
};
export var Component = function Component(_ref, ref) {
  var onLoad = _ref.onLoad,
    onError = _ref.onError,
    src = _ref.src,
    sources = _ref.sources,
    className = _ref.className,
    alt = _ref.alt,
    title = _ref.title,
    objectFit = _ref.objectFit;
  return /*#__PURE__*/React.createElement("picture", {
    className: className
  }, sources.map(function (_ref2) {
    var srcset = _ref2.srcset,
      media = _ref2.media,
      sizes = _ref2.sizes;
    return /*#__PURE__*/React.createElement("source", {
      key: srcset + (media || '') + (sizes || ''),
      srcSet: srcset,
      media: media,
      sizes: sizes,
      type: getMimeType(srcset)
    });
  }), /*#__PURE__*/React.createElement("img", {
    className: styles['image'],
    alt: alt,
    title: title,
    decoding: 'async',
    style: {
      objectFit: objectFit
    },
    onLoad: onLoad,
    onError: onError,
    src: src,
    ref: ref
  }));
};
Component.displayName = 'Picture';
export var Picture = /*#__PURE__*/React.forwardRef(Component);